import { render, staticRenderFns } from "./add_position_level.vue?vue&type=template&id=a36f3f02&scoped=true&"
import script from "./add_position_level.vue?vue&type=script&lang=js&"
export * from "./add_position_level.vue?vue&type=script&lang=js&"
import style0 from "./add_position_level.vue?vue&type=style&index=0&id=a36f3f02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36f3f02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a36f3f02')) {
      api.createRecord('a36f3f02', component.options)
    } else {
      api.reload('a36f3f02', component.options)
    }
    module.hot.accept("./add_position_level.vue?vue&type=template&id=a36f3f02&scoped=true&", function () {
      api.rerender('a36f3f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/task/form/add_position_level.vue"
export default component.exports